<span class="font-semibold text-lg my-4">Review and Pay</span>
@if (selectedQR) {
  <div class="px-2 rounded-2xl mt-2 text-md sm:text-sm">
    <sbd-account-portal-frontend-accordion-content
      [item]="selectedQR"
      [useAccordionComponent]="false"
      [showSelectedDeliveryOption]="true"
      (updatedOpenQR)="updateSelectedQuoteOption($event)"
    ></sbd-account-portal-frontend-accordion-content>
  </div>
} @else {
  <div class="px-2 rounded-2xl mt-2 text-md sm:text-sm" *ngFor="let openQR of queuedQR">
    <sbd-account-portal-frontend-accordion-content
      [item]="openQR"
      [useAccordionComponent]="false"
      [showSelectedDeliveryOption]="true"
      (updatedOpenQR)="updateSelectedQuoteOption($event)"
    ></sbd-account-portal-frontend-accordion-content>
  </div>
}
